import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { HandlingUnitItemInitialState, SetHandlingUnitItemParams } from './handling-unit-item.actions';
import { MonitoringPageType } from '../../monitoring/constants';

export interface HandlingUnitItemStateModel {
  handlingUnitNumber: string;
  deliveryNoteNumber: string;
  sapId: string;
  parentRoute: boolean;
  monitoringPageType: MonitoringPageType;
}

const initialState: HandlingUnitItemStateModel = {
  handlingUnitNumber: null,
  deliveryNoteNumber: null,
  sapId: null,
  parentRoute: false,
  monitoringPageType: null,
};

@State<HandlingUnitItemStateModel>({
  name: 'handlingUnitItem',
  defaults: initialState,
})
@Injectable()
export class HandlingUnitItemState {
  @Selector()
  static getState(state: HandlingUnitItemStateModel): HandlingUnitItemStateModel {
    return state;
  }
  @Selector()
  static getHandlingUnitNumber(state: HandlingUnitItemStateModel): string {
    return state.handlingUnitNumber;
  }
  @Selector()
  static getDeliveryNoteNumber(state: HandlingUnitItemStateModel): string {
    return state.deliveryNoteNumber;
  }

  @Selector()
  static getSapId(state: HandlingUnitItemStateModel): string {
    return state.sapId;
  }
  @Selector()
  static hasParentRoute(state: HandlingUnitItemStateModel): boolean {
    return state.parentRoute;
  }

  @Selector()
  static getMonitoringPageType(state: HandlingUnitItemStateModel): MonitoringPageType {
    return state.monitoringPageType;
  }

  @Action(SetHandlingUnitItemParams)
  setStateData(ctx: StateContext<HandlingUnitItemStateModel>, { payload }: SetHandlingUnitItemParams): void {
    ctx.patchState({ ...payload });
  }

  @Action(HandlingUnitItemInitialState)
  setInitialState(ctx: StateContext<HandlingUnitItemInitialState>): void {
    ctx.setState(initialState);
  }
}
